// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"237":"SociosForm","312":"SociosLista"}[chunkId] + ".css";
};